import { Directive, Output, HostListener, EventEmitter, Input } from '@angular/core';
import { Uploader } from './uploader';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[dropZone]',
})
export class DropZoneDirective extends Uploader {
  @Input() files;
  @Input() maxFiles;
  @Input() fileTypes;
  @Input() allowDuplicates;
  @Input() maxRes;
  @Input() minRes;
  @Input() exactRes;
  @Input() maxSize;
  @Input() status;
  @Input() storagePath;

  @Output() filesOver = new EventEmitter<FileList | boolean>();
  @Output() filesDropped = new EventEmitter<Uploader.FileItem[]>();
  @Output() fileUploaded = new EventEmitter<any>();
  @Output() fileAdded = new EventEmitter<any>();
  @Output() statusChanged = new EventEmitter<any>();

  constructor() {
    super();
  }

  @HostListener('drop', ['$event'])
  onDrop(event: any): void {
    this._preventAndStop(event);
    if (
      (
        this.status =
          this._dropStatus(Array.from(event.dataTransfer.files), event.dataTransfer.types)
      )
        === Uploader.UploadStatus.VALID
    ) {
      this.addFiles(this._fileListToFileItems(event.dataTransfer.files));
      this.filesDropped.emit(this.files);
      this.filesOver.emit(false);
    }
  }

  @HostListener('dragover', ['$event'])
  onDragOver(event: any): void {
    this.status = this._dropStatus(Array.from(event.dataTransfer.items), event.dataTransfer.types);
    event.dataTransfer.dropEffect = 'copy';
    this._preventAndStop(event);
    this.filesOver.emit(event.dataTransfer.files);
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: any): void {
    this.status = null;
    this._preventAndStop(event);
    this.filesOver.emit(event.dataTransfer.files);
  }

  private _dropStatus(files: any[], types: string[] = ['Files']): Uploader.UploadStatus {
    if (types.includes('Files')) {
      if (this.maxFiles && (files.length + this.files.length) > this.maxFiles) {
        return Uploader.UploadStatus.MAX_FILES;
      }
      return files.some(file => !this._validFileType(file)) ?
        Uploader.UploadStatus.INVALID_TYPE :
        Uploader.UploadStatus.VALID;
    } else {
      return Uploader.UploadStatus.INVALID_DROP;
    }
  }
}
